import { useEffect, useState } from "react";
import { useParams, Navigate } from "react-router-dom";
import { api } from "../lib/api";

export default function SalePrintPage() {
  const { id } = useParams();
  const [sale, setSale] = useState(null);
  const [err, setErr] = useState(false);
  const [authed, setAuthed] = useState(null);

  useEffect(() => {
    if (!localStorage.getItem("kk_token")) { setAuthed(false); return; }
    api.get("/auth/me").then(() => setAuthed(true)).catch(() => setAuthed(false));
  }, []);

  useEffect(() => {
    if (!authed) return;
    api.get(`/admin/sales/${id}`).then((r) => {
      setSale(r.data);
      setTimeout(() => window.print(), 600);
    }).catch(() => setErr(true));
  }, [id, authed]);

  if (authed === false) return <Navigate to="/admin/login" replace />;
  if (authed === null) return null;
  if (err) return <div className="p-10 text-center">Bon inexistent</div>;
  if (!sale) return <div className="p-10 text-center text-neutral-500">Se incarca...</div>;

  const dt = new Date(sale.created_at).toLocaleString("ro-RO");
  const PAY_RO = { cash: "Numerar", card: "Card", transfer: "Transfer bancar" };

  return (
    <div className="bg-white text-black min-h-screen">
      <style>{`
        @page { size: 80mm auto; margin: 4mm; }
        @media print { .no-print { display: none !important; } body { background: white !important; } }
        .receipt { font-family: 'Outfit', 'Courier New', monospace; max-width: 80mm; margin: 0 auto; padding: 8px; font-size: 11px; }
        .receipt h1, .receipt h2 { font-family: 'Anton', sans-serif; }
      `}</style>

      <div className="no-print fixed top-4 right-4 flex gap-2 z-50">
        <button onClick={() => window.print()} className="bg-[#00E5FF] text-black font-semibold px-4 py-2 text-sm uppercase">Printeaza</button>
        <button onClick={() => window.close()} className="border border-neutral-400 text-neutral-700 px-4 py-2 text-sm">Inchide</button>
      </div>

      <div className="receipt">
        <div className="text-center pb-2 border-b-2 border-dashed border-black mb-3">
          <h1 className="text-lg font-bold uppercase">TROTI-X SERVICE</h1>
          <div className="text-[10px] mt-1">Bd. Liviu Rebreanu 104A, Timisoara</div>
          <div className="text-[10px]">Tel: 0743 110 277</div>
          <div className="text-[10px]">trotinete-ieftine.ro</div>
        </div>

        <div className="mb-3 text-[10px]">
          <div className="flex justify-between"><span>Bon nr:</span><strong>#{sale.receipt_no}</strong></div>
          <div className="flex justify-between"><span>Data:</span><span>{dt}</span></div>
          {sale.customer_name && <div className="flex justify-between"><span>Client:</span><span>{sale.customer_name}</span></div>}
          {sale.customer_phone && <div className="flex justify-between"><span>Tel:</span><span>{sale.customer_phone}</span></div>}
          <div className="flex justify-between"><span>Plata:</span><span>{PAY_RO[sale.payment_method] || sale.payment_method}</span></div>
        </div>

        <div className="border-t border-dashed border-black pt-2 mb-2">
          <div className="text-[10px] font-bold uppercase mb-1">Produse:</div>
          {sale.items.map((l, i) => (
            <div key={i} className="mb-1.5">
              <div className="font-medium">{l.name}</div>
              <div className="flex justify-between text-[10px]">
                <span>{l.quantity} x {l.unit_price} RON</span>
                <span><strong>{l.line_total} RON</strong></span>
              </div>
            </div>
          ))}
        </div>

        <div className="border-t border-dashed border-black pt-2 space-y-1 text-[10px]">
          <div className="flex justify-between"><span>Subtotal:</span><span>{sale.subtotal.toFixed(2)} RON</span></div>
          {sale.discount > 0 && <div className="flex justify-between"><span>Discount:</span><span>-{sale.discount.toFixed(2)} RON</span></div>}
          <div className="flex justify-between text-lg font-bold border-t border-black pt-1 mt-1">
            <span>TOTAL:</span><span>{sale.total.toFixed(2)} RON</span>
          </div>
        </div>

        {sale.notes && <div className="text-[10px] italic mt-3 pt-2 border-t border-dashed border-black">Note: {sale.notes}</div>}

        <div className="text-center mt-4 pt-3 border-t-2 border-dashed border-black text-[10px]">
          <div>Multumim pentru cumparatura!</div>
          <div className="mt-1">Program: L-V 9-17 · Sambata 9-14</div>
          <div className="mt-2 text-[9px]">Pastrati bonul pentru orice reclamatie</div>
        </div>
      </div>
    </div>
  );
}
